import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { FornecedorItemResponse } from "../typings";

function useFornecedores(params: PaginateQuery) {
  return useQuery([`/v1/fornecedor`, params], async () => {
    const { data } = await axios.get<PaginateResult<FornecedorItemResponse>>(
      `/v1/fornecedor`,
      {
        params,
      }
    );

    return data;
  });
}

export default useFornecedores;
